module.exports = __webpack_public_path__ + "img/17.9.TU.536cc3fe.png";